import { useEffect, useState } from 'react';
import { mediaQuery, Spacings } from '@styles/index';
import Drawer from '@base/Drawer/Drawer';
import styled from '@emotion/styled';
import Image from '@base/Image';
import H3 from '@base/H3/H3';
import H4 from '@base/H4/H4';
import H5 from '@base/H5/H5';
import P2 from '@base/P2/P2';
import Tab from '@material-ui/core/Tab';
import P1 from '@base/P1/P1';
import StyledTabs from '@base/Tabs/Tabs';

const RewardDetailWrapper = styled.div`
  grid-column: span 10;
  margin-bottom: ${Spacings.SPACING_8B};
  margin-top: ${Spacings.SPACING_3B};
`;

const TabContainer = styled(StyledTabs)`
  margin-bottom: ${Spacings.SPACING_8B};
  .MuiTabs-indicator {
    border-radius: 5px 5px 0 0;
  }
  .MuiTab-root {
    min-width: max-content;
    margin-right: ${Spacings.SPACING_4B};
    font-size: 14px;
  }
`;

const RewardDetailItemWrapper = styled.div`
  margin-top: ${Spacings.SPACING_10B};
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
`;

const RewardDetailItem = styled.div`
  border: 1px solid var(--color-i-divider);
  border-radius: ${Spacings.SPACING_2B};
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
`;

const RewardDetailIcon = styled.div`
  position: relative;
  width: ${({ $rewardType }) => ($rewardType === 'Laptop' ? '60px' : '40px')};
  height: ${Spacings.SPACING_10B};
`;

const RewardDetailInfo = styled.div`
  margin-top: ${Spacings.SPACING_4B};
`;

const RewardTable = styled.img`
  width: 432px;
  margin-top: ${Spacings.SPACING_4B};
  background: var(--color-i-violet-dark-1);
  border-radius: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    width: 296px;
  }
`;

const RewardTitle = styled(H5)`
  margin-bottom: ${Spacings.SPACING_2B};
`;

const ReferralRewardsWrapper = styled.div`
  margin-top: ${Spacings.SPACING_10B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_6B};
  }
`;

const ReferralRewardsPointWrapper = styled.div`
  margin-top: ${Spacings.SPACING_6B};
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
`;

const ReferralRewardsPoints = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_2B};
  flex-shrink: ${Spacings.SPACING_0B};
`;

const ReferralRewardsIcon = styled.div`
  position: absolute;
  width: ${Spacings.SPACING_5B};
  height: ${Spacings.SPACING_5B};
  flex-shrink: ${Spacings.SPACING_0B};
`;

const NotesText = styled(P1)`
  margin-left: ${Spacings.SPACING_7B};
`;

const RewardDetails = styled.div`
  align-items: flex-start;
  padding: ${Spacings.SPACING_4B};
`;

const DetailsTitle = styled(H3)`
  margin-bottom: ${Spacings.SPACING_3B};
`;

const RewardDetail = ({ drawerState, closeRewardDetailDrawer, drawerData }) => {
  const defaultTab = 0;
  const [selectedTab, setSelectedTab] = useState(defaultTab);
  const [rewardData, setRewardData] = useState(drawerData?.freeUser);
  const handleTabChange = (e, newTabValue) => {
    setRewardData(newTabValue ? drawerData.paidUser : drawerData.freeUser);
    setSelectedTab(newTabValue);
  };
  const tabs = [
    {
      label: 'Free learners',
      value: 0
    },
    {
      label: 'Plus & Iconic learners',
      value: 1
    }
  ];

  useEffect(() => {
    setRewardData(drawerData?.freeUser);
  }, [drawerData]);

  if (!rewardData) return null;

  return (
    <Drawer drawerState={drawerState} onClose={closeRewardDetailDrawer}>
      <RewardDetailWrapper>
        <DetailsTitle>Reward details</DetailsTitle>
        <TabContainer
          value={selectedTab}
          $selectedTabColor="var(--color-base-fill)"
          onChange={handleTabChange}
        >
          {tabs.map((tab, index) => (
            <Tab label={tab.label} key={tab.value} value={index} />
          ))}
        </TabContainer>
        <RewardDetailItemWrapper>
          {rewardData.rewardDetails?.map((reward, index) => (
            <RewardDetailItem key={String(index)}>
              <RewardDetails>
                <RewardDetailIcon $rewardType={reward.type}>
                  <Image src={reward.icon} alt="reward" layout="fill" />
                </RewardDetailIcon>
                <RewardDetailInfo>
                  <RewardTitle>{reward.extendedLabel}</RewardTitle>
                  <P2 color="var(--color-text-secondary)">
                    {reward.extendedSubLabel}
                  </P2>
                  {reward?.rewardTable && (
                    <RewardTable src={reward.rewardTable} />
                  )}
                </RewardDetailInfo>
              </RewardDetails>
            </RewardDetailItem>
          ))}
        </RewardDetailItemWrapper>
        {rewardData.termsAndConditions && (
          <ReferralRewardsWrapper>
            <H4>Important notes</H4>
            <ReferralRewardsPointWrapper>
              {rewardData.termsAndConditions.map((reward, index) => {
                return (
                  <ReferralRewardsPoints key={String(index)}>
                    <ReferralRewardsIcon>
                      <Image
                        src="referrals/checkmark.svg"
                        layout="fill"
                        alt="avatar"
                      />
                    </ReferralRewardsIcon>
                    <NotesText>{reward}</NotesText>
                  </ReferralRewardsPoints>
                );
              })}
            </ReferralRewardsPointWrapper>
          </ReferralRewardsWrapper>
        )}
      </RewardDetailWrapper>
    </Drawer>
  );
};

export default RewardDetail;
